import { Button, Message, Space, Tag } from "@arco-design/web-react";

export function CopyableText({ value, label }: { value: string; label?: string }): JSX.Element {
  const handleCopy = async (): Promise<void> => {
    try {
      await navigator.clipboard.writeText(value);
      Message.success("已复制");
    } catch (err) {
      Message.error(`复制失败：${(err as Error).message}`);
    }
  };
  return (
    <Space>
      {label && <Tag color="arcoblue">{label}</Tag>}
      <code style={{ background: "#f2f3f5", padding: "2px 8px", borderRadius: 4, fontSize: 13 }}>
        {value}
      </code>
      <Button size="mini" onClick={handleCopy}>
        复制
      </Button>
    </Space>
  );
}
